import React, { useEffect, useState } from "react";
import { C } from "../theme";

export default function PulseDot({ color = C.red }) {
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const id = setInterval(() => setScale((s) => (s === 1 ? 1.6 : 1)), 800);
    return () => clearInterval(id);
  }, []);

  return (
    <div style={{ position: "relative", width: 12, height: 12 }}>
      <div
        style={{
          position: "absolute",
          inset: 0,
          borderRadius: "50%",
          background: color,
          transform: `scale(${scale})`,
          transition: "transform 0.6s ease",
          opacity: 0.3,
        }}
      />
      <div
        style={{
          position: "absolute",
          inset: 2,
          borderRadius: "50%",
          background: color,
        }}
      />
    </div>
  );
}
